module.exports = "/assets/data/4842bbe5522c2fcc06dff4084d1cdf2b-AB25.data.json";